import moment from 'moment'
import api from '../../services/service_report'
import apipos from '../../services/service_pos'

export default {
  data () {
    return {
      host_list: [],
      report_data: [],
      host: '',
      start_date: moment(new Date()),
      end_date: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: ''
    }
  },
  methods: {
    getHost () {
      apipos.getHostShift(
        this.REST_URL,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            this.getExpend()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getExpend () {
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.user.company_id,
        branch_id: this.$store.state.user.branch_id,
        begin_date: this.dateFormatDMY2(this.start_date),
        end_date: this.dateFormatDMY2(this.end_date)
      }
      this.$store.commit('Loading')
      api.expenseReport(
        this.REST_URL,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
            this.form_host = JSON.stringify(this.host)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    count_expen (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['amount']
      })
      return sum
    }
  },
  mounted () {
    this.getHost()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_expend.js